import React from "react";
import IMAGES from "../../constant/IMAGES";
import { CloseButtonProps } from "react-toastify";

const CustomCloseButton = ({ closeToast }: CloseButtonProps) => {
  return (
    <button
      aria-label="remove"
      type="button"
      className="absolute top-4 right-4"
      onClick={() => {
        console.log("closeToast", closeToast);
        closeToast(true);
      }}
    >
      <img src={IMAGES.iconClose} alt="icon-close" className="size-6" />
    </button>
  );
};

export default CustomCloseButton;
